var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":"Editar datos de la cama","type":"is-dark"}},[_c('b-button',{attrs:{"type":"is-primary","size":"is-small","icon-left":"pen-square"},on:{"click":_vm.openModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }